import { capitalGainsTaxRate, DEFAULT_CAPITAL_GAINS_INCOME_TAX_RATE, DEFAULT_TAX_RESIDENCY, socialContributionRateFor, } from './tax/fr/index.js';
/**
 * Valeurs de la feuille `Hypothèses` du classeur MMI de référence.
 * `capitalGainsTaxRate` reprend la formule du classeur, `=45 % × F17` : 45 % de
 * l'assiette des prélèvements sociaux subsiste après 25 ans de détention (D1).
 */
export const MMI_2026_ASSUMPTIONS = {
    acquisitionYear: 2026,
    inflation: 0.011,
    housingPriceGrowth: 0.015,
    personalTaxRate: 0.1,
    socialContributionRate: 0.075,
    capitalGainsTaxRate: 0.45 * 0.075,
    buildingDepreciationYears: 15,
    furnitureDepreciationYears: 5,
    landShare: 0.1,
};
/**
 * Hypothèses dérivées de la résidence fiscale : `taxResidency` pilote à la fois les
 * prélèvements sociaux (7,5 % ou 17,2 %) et l'impôt sur la plus-value après abattements.
 *
 * Pour le foyer, à 25 ans : prélèvements sociaux 7,5 %, plus-value taxée à **3,375 %** —
 * exactement la valeur que le classeur MMI pose en dur (`=45 % × F17`).
 */
export function createMmiAssumptions(options = {}) {
    const residency = options.taxResidency ?? DEFAULT_TAX_RESIDENCY;
    const socialContributionRate = socialContributionRateFor(residency);
    return {
        ...MMI_2026_ASSUMPTIONS,
        socialContributionRate,
        capitalGainsTaxRate: capitalGainsTaxRate({
            yearsHeld: options.holdingYears ?? 25,
            incomeTaxRate: options.capitalGainsIncomeTaxRate ?? DEFAULT_CAPITAL_GAINS_INCOME_TAX_RATE,
            socialRate: socialContributionRate,
        }).total,
        ...(options.capitalGainsIncomeTaxRate !== undefined && {
            capitalGainsIncomeTaxRate: options.capitalGainsIncomeTaxRate,
        }),
        ...options.overrides,
    };
}
//# sourceMappingURL=assumptions.js.map